import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { accountNumber, password, username, userPassMap } from '../internal.js'

const credentialTypes = [
  username,
  password,
  'client-id',
  'client-secret',
] as const
const locationCredentialTypes = [accountNumber] as const

export type mgulCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const mgulDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const mgul: CarrierDef<mgulCredType> = {
  name: 'Magnum',
  scac: 'mgul',
  ltlServices: [{ id: 'standard', name: 'Standard' }],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [...userPassMap, ['account-number', 'ref1']],
  engineLayers: ['rating', 'pickup', 'tracking', 'profinder', 'documents'],
  documentTypes: mgulDocumentTypes,
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
